/**
 * The code a product with no barcode of its own is given (SSD-7611, FC request 14-2): an EAN-13 in the
 * restricted-circulation 29 range, the SKU padded to ten digits, and the check digit. Digits only, because
 * the product master refuses anything else; GS1 leaves 20-29 to each company for its own use (stores print
 * weight and price labels there), so no brand's retail barcode is issued in it. Not 04: the desk scanner reads a code that starts with 0 as a 12-digit US code and drops
 * the 0, so the scan never matched the stored 13 digits (FC desk test, 2026-10-23). A SKU gives one code and
 * no other SKU gives the same one, since a SKU with a leading zero (which would pad to another SKU's code)
 * makes none.
 */
export const INTERNAL_BARCODE_PREFIX = '29';

const SKU_DIGITS = 10;

/** The EAN-13 check digit of the first twelve digits. */
export const ean13CheckDigit = (twelve: string): number => {
  const sum = [...twelve].reduce((total, digit, index) => total + Number(digit) * (index % 2 === 0 ? 1 : 3), 0);
  return (10 - (sum % 10)) % 10;
};

/** The internal code for a SKU, or null for a SKU that is not all digits, starts with 0, or runs past ten digits. */
export const internalBarcodeFor = (sku: string): string | null => {
  const digits = sku.trim();
  if (!/^[1-9]\d*$/.test(digits) || digits.length > SKU_DIGITS) {
    return null;
  }
  const twelve = INTERNAL_BARCODE_PREFIX + digits.padStart(SKU_DIGITS, '0');
  return twelve + String(ean13CheckDigit(twelve));
};

export const INTERNAL_BARCODE_UNAVAILABLE = 'Only a SKU of up to 10 digits gets a code';
